module.exports = __webpack_public_path__ + "assets/images/project/constituencies/chua-chu-kang-grc.jpg?v=32198741";